import { useEffect } from "react";
import { notify } from "../components/ui";
import { t } from "../i18n";
import { showError, showSuccess } from "../lib/feedback";

const REDIRECT_PARAM = "email_conectado";
const REASON_PARAM = "motivo";

// O backend redireciona o navegador de volta para o app com esse query param
// depois da tela de consentimento do Google (?email_conectado=1|0). Chamado
// uma única vez a partir do ProtectedRoute — que envolve praticamente toda
// rota autenticada — para capturar o retorno independentemente de qual
// página o backend usa como destino (APP_URL).
export function useEmailConnectionRedirect(onResult?: (success: boolean) => void): void {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (!params.has(REDIRECT_PARAM)) return;

    const success = params.get(REDIRECT_PARAM) === "1";
    // Só existe quando `email_conectado=0` e o médico concluiu o consentimento
    // sem marcar a permissão de envio (escopo `gmail.send`) — o Google não
    // retorna erro nesse caso, então o backend precisa sinalizar isso aqui.
    const motivo = params.get(REASON_PARAM);

    params.delete(REDIRECT_PARAM);
    params.delete(REASON_PARAM);
    const newSearch = params.toString();
    window.history.replaceState(
      {},
      document.title,
      `${window.location.pathname}${newSearch ? `?${newSearch}` : ""}${window.location.hash}`
    );

    if (success) {
      showSuccess("emailAccountConnected");
    } else if (motivo === "permissao_negada") {
      notify({ tone: "error", title: t("settings.emailAccount.permissionDeniedTitle"), body: t("settings.emailAccount.permissionDeniedBody") });
    } else {
      showError("email-oauth-failed");
    }

    onResult?.(success);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
